import { useMemo } from 'react';
import { useSearchParams } from 'react-router-dom';
import { CartItemsList } from '../cart';
import type { CartAmazonDeal, CartGetItem } from '../../types';

type Props = {
  cartItems: CartGetItem[];
  cartVendor: string;
  cartTimestamp: number;
  cartCCY: string;
  cartCCYS: string;
  cartLocale?: string;
  dealForItem?: (item: CartGetItem) => CartAmazonDeal | null;
};

export const ReceiveCartItems = ({
  cartItems,
  cartVendor,
  cartTimestamp,
  cartCCY,
  cartCCYS,
  cartLocale,
  dealForItem,
}: Props) => {
  const [searchParams] = useSearchParams();

  const rawMissing = searchParams.get('missing');
  const missingAsins = useMemo(() => {
    return rawMissing
      ? rawMissing
          .split(',')
          .map((s) => s.trim())
          .filter(Boolean)
      : [];
  }, [rawMissing]);

  const sortedCartItems = useMemo(() => {
    const items = cartItems ?? [];
    if (items.length === 0 || missingAsins.length === 0) {
      return items;
    }

    const missing: CartGetItem[] = [];
    const rest: CartGetItem[] = [];

    items.forEach((item) => {
      if (missingAsins.includes(item.asin)) {
        missing.push(item);
      } else {
        rest.push(item);
      }
    });

    return [...missing, ...rest];
  }, [cartItems, missingAsins]);

  return (
    <CartItemsList
      page='receive'
      missingAsins={missingAsins}
      cartItems={sortedCartItems}
      cartVendor={cartVendor}
      cartCCY={cartCCY}
      cartCCYS={cartCCYS}
      cartLocale={cartLocale}
      dealForItem={dealForItem}
    />
  );
};
